import { SegmentRegistrationStatus } from '@hopin-team/api-hopin';

export interface SegmentsData {
  segmentsStatus: SegmentRegistrationStatus[] | undefined;
  segmentExternalId: string | undefined;
}

export const segmentStatusSelector = ({
  segmentsStatus = [],
  segmentExternalId,
}: SegmentsData) => {
  const segment = segmentsStatus.find(s => {
    return s.schedule_external_id === segmentExternalId;
  });
  if (segment)
    return {
      isAlreadyBooked: segment.user_registered,
      remainingCapacity:
        segment.remaining != null && segment.remaining >= 0
          ? segment.remaining
          : null,
    };

  return {
    isAlreadyBooked: false,
    remainingCapacity: null,
  };
};
